window.Vue = require("vue");

import Dayjs from 'vue-dayjs';

Vue.use(Dayjs);
